import {Form} from "@/utils/Form";
import {Auth, useAuth} from "@/context/AuthProvider";
import {UpdateFaxMutation, UpdateFaxMutationVariables, useUpdateFaxMutation} from "../mutations.generated";
import {DataSource} from "./DataSource";
import deepEqual from "deep-equal";

export default class UpdateFaxForm extends Form<UpdateFaxMutation, UpdateFaxMutationVariables> {
    private readonly auth: Auth;
    readonly dataSource: DataSource;

    constructor(dataSource: DataSource) {
        super("updateFax");
        this.hooks(useUpdateFaxMutation, dataSource.fax);
        this.auth = useAuth();
        this.dataSource = dataSource;
    }

    protected override get filteredVariables(): UpdateFaxMutationVariables {
        const values = structuredClone(this.values);

        if (!this.auth.hasPermission("edit_fax_superuser")) {
            delete values.outgoingCallBarringOperator;
            delete values.nonPaymentBlockingType;
        }

        return values;
    }

    override get hasChanged(): boolean {
        return !deepEqual(this.initialData, this.values);
    }
}
